import type { Chapter } from '@/domain/model/Chapter';

export const getTotalCourses = (chapters?: Chapter[]): number =>
  chapters?.reduce((total, chapter) => total + (chapter.courses?.length || 0), 0) || 0;

export const getTotalDurationHours = (chapters?: Chapter[]): number => {
  const totalSeconds =
    chapters?.reduce(
      (total, chapter) =>
        total + (chapter.courses?.reduce((sum, course) => sum + (course.duration || 0), 0) || 0),
      0,
    ) || 0;
  return Math.round((totalSeconds / 3600) * 10) / 10;
};
